const STOCKS_BASE_URL = "https://www.incredmoney.com/stocks";
const INDICES_BASE_URL = "https://www.incredmoney.com/indices";

/** Display names whose URL slug does not match the default name → kebab mapping. */
const INDEX_SLUG_OVERRIDES: Record<string, string> = {
    "BSE Sensex": "sensex",
};

/**
 * Converts a market display name into the incredmoney.com URL slug.
 * "Tata Power Company Ltd" → "tata-power-company-ltd"
 * "Nifty 50" → "nifty-50"
 */
export function toStockSlug(name: string): string {
    return name
        .toLowerCase()
        .trim()
        .replace(/&/g, "and")
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/-+/g, "-")
        .replace(/^-|-$/g, "");
}

/** "Reliance Industries Ltd" → "https://www.incredmoney.com/stocks/reliance-industries-ltd" */
export function getStockPageUrl(name: string): string {
    return `${STOCKS_BASE_URL}/${toStockSlug(name)}`;
}

/** "Nifty Bank" → "https://www.incredmoney.com/indices/nifty-bank" */
export function getIndexPageUrl(name: string): string {
    const slug = INDEX_SLUG_OVERRIDES[name] ?? toStockSlug(name);
    return `${INDICES_BASE_URL}/${slug}`;
}

/** Hub page for all indices: https://www.incredmoney.com/indices */
export function getIndicesListUrl(): string {
    return INDICES_BASE_URL;
}
